/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  partijen : data.partijen
}
const getters = {
  getPartijenList: state => {
    return state.partijen;
  },
  getPartijById: state => ({ id }) => {
    return selectOne({
      from: state.partijen, 
      property: 'id', 
      value: id
    });
  },
  getPartijBySlug: state => ({ slug }) => {
    return selectOne({
      from: state.partijen, 
      property: 'slug', 
      value: slug
    });
  },
}
const actions = {}
const mutations = {
  setPartijen(state, { dataset }) {
    state.partijen = dataset.partijen
  }
}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
